/* Albindress — product.js
   Selezione varianti (Section Rendering API con option_values), galleria media,
   prodotti consigliati. */
(function () {
  'use strict';

  const SG = (window.Albin = window.Albin || {});

  if (!customElements.get('product-info')) {
    customElements.define(
      'product-info',
      class ProductInfo extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.sectionId;
          this.productUrl = this.dataset.url;
          this.updateUrl = this.dataset.updateUrl !== 'false';
          this.abortController = null;
          this.addEventListener('change', (event) => {
            if (event.target.closest('[data-variant-picker]')) this.onOptionChange(event);
          });
          this.addEventListener('click', (event) => {
            const thumb = event.target.closest('[data-media-thumb]');
            if (thumb) {
              event.preventDefault();
              this.showMedia(thumb.getAttribute('data-media-thumb'), true);
            }
          });
          const track = this.querySelector('[data-gallery-track]');
          if (track && 'IntersectionObserver' in window) {
            const observer = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
                    this.markThumb(entry.target.getAttribute('data-media-id'));
                  }
                });
              },
              { root: track, threshold: [0.6] }
            );
            track.querySelectorAll('[data-media-id]').forEach((el) => observer.observe(el));
          }
          this.initModels();
          this.initStickyBar();
        }

        /* Barra di acquisto fissa: visibile quando il pulsante principale è uscito dallo schermo verso l'alto */
        initStickyBar() {
          const bar = this.querySelector('[data-sticky-atc]');
          const main = this.querySelector('.product-form__submit');
          if (!bar || !main) return;
          bar.hidden = false;
          let ticking = false;
          let shown = null;
          const update = () => {
            ticking = false;
            const passed = main.getBoundingClientRect().bottom < 0;
            if (passed === shown) return;
            shown = passed;
            bar.classList.toggle('is-visible', passed);
            bar.toggleAttribute('inert', !passed);
          };
          const onScroll = () => {
            if (!ticking) {
              ticking = true;
              window.requestAnimationFrame(update);
            }
          };
          window.addEventListener('scroll', onScroll, { passive: true });
          window.addEventListener('resize', onScroll);
          update();
        }

        selectedOptionValueIds() {
          const picker = this.querySelector('[data-variant-picker]');
          if (!picker) return [];
          const ids = [];
          picker.querySelectorAll('[data-option-group]').forEach((group) => {
            const select = group.querySelector('select');
            if (select) {
              const option = select.options[select.selectedIndex];
              if (option) ids.push(option.dataset.optionValueId);
            } else {
              const checked = group.querySelector('input[type="radio"]:checked');
              if (checked) ids.push(checked.dataset.optionValueId);
            }
          });
          return ids.filter(Boolean);
        }

        async onOptionChange(event) {
          const ids = this.selectedOptionValueIds();
          const focusedId = event.target.id;
          if (this.abortController) this.abortController.abort();
          this.abortController = new AbortController();
          this.setBusy(true);
          try {
            const url = this.productUrl + '?section_id=' + encodeURIComponent(this.sectionId) + '&option_values=' + ids.join(',');
            const response = await fetch(url, { signal: this.abortController.signal });
            if (!response.ok) throw new Error(response.statusText);
            const html = await response.text();
            this.applyUpdate(SG.parseHTML(html), focusedId);
          } catch (error) {
            if (error.name === 'AbortError') return;
            SG.announce(SG.strings.cartError, true);
          } finally {
            this.setBusy(false);
          }
        }

        setBusy(busy) {
          const region = this.querySelector('[data-product-price]');
          if (region) region.setAttribute('aria-busy', String(busy));
        }

        applyUpdate(doc, focusedId) {
          const source = doc.querySelector('product-info[data-section-id="' + this.sectionId + '"]');
          if (!source) return;

          ['[data-variant-picker]', '[data-product-price]', '[data-product-inventory]', '[data-product-sku]', '[data-variant-status]', '[data-sticky-price]'].forEach((selector) => {
            const from = source.querySelector(selector);
            const to = this.querySelector(selector);
            if (from && to) to.innerHTML = from.innerHTML;
          });

          const variantId = source.dataset.selectedVariant;
          const available = source.dataset.variantAvailable === 'true';
          this.dataset.selectedVariant = variantId || '';

          // Aggiorna gli input "id" di tutti i moduli prodotto di questa sezione
          this.querySelectorAll('form[data-product-form] input[name="id"]').forEach((input) => {
            input.value = variantId || '';
            input.disabled = !variantId;
          });

          const newButton = source.querySelector('[data-add-to-cart]');
          this.querySelectorAll('[data-add-to-cart]').forEach((button) => {
            if (!newButton) return;
            button.disabled = newButton.disabled;
            const label = button.querySelector('[data-add-to-cart-label]');
            const newLabel = newButton.querySelector('[data-add-to-cart-label]');
            if (label && newLabel) label.textContent = newLabel.textContent;
          });

          const payment = this.querySelector('[data-payment-button]');
          if (payment) payment.hidden = !available;

          const quantity = this.querySelector('[data-product-quantity] input');
          const newQuantity = source.querySelector('[data-product-quantity] input');
          if (quantity && newQuantity) {
            ['min', 'max', 'step'].forEach((attr) => {
              if (newQuantity.hasAttribute(attr)) quantity.setAttribute(attr, newQuantity.getAttribute(attr));
              else quantity.removeAttribute(attr);
            });
          }

          if (variantId && this.updateUrl) {
            const url = new URL(window.location.href);
            url.searchParams.set('variant', variantId);
            window.history.replaceState({}, '', url.toString());
          }

          const mediaId = source.dataset.featuredMedia;
          if (mediaId) this.showMedia(mediaId, false);

          if (focusedId) {
            const el = document.getElementById(focusedId);
            if (el) el.focus({ preventScroll: true });
          }

          const status = this.querySelector('[data-variant-status]');
          if (status && status.textContent.trim()) SG.announce(status.textContent.trim());
        }

        showMedia(mediaId, moveFocus) {
          const track = this.querySelector('[data-gallery-track]');
          const item = this.querySelector('[data-media-id="' + mediaId + '"]');
          if (!track || !item) return;
          // Galleria affiancata su desktop: la foto della variante scelta passa in prima posizione
          if (track.scrollWidth <= track.clientWidth + 2 && !moveFocus) {
            if (track.firstElementChild !== item) track.prepend(item);
            return;
          }
          track.scrollTo({
            left: item.offsetLeft - track.offsetLeft,
            behavior: SG.prefersReducedMotion() ? 'auto' : 'smooth',
          });
          this.markThumb(mediaId);
          if (moveFocus) {
            item.setAttribute('tabindex', '-1');
            item.focus({ preventScroll: true });
          }
        }

        markThumb(mediaId) {
          const items = Array.from(this.querySelectorAll('[data-gallery-track] [data-media-id]'));
          const index = items.findIndex((el) => el.getAttribute('data-media-id') === mediaId);
          const counter = this.querySelector('[data-gallery-current]');
          if (counter && index > -1) counter.textContent = String(index + 1);
          this.querySelectorAll('[data-media-thumb]').forEach((thumb) => {
            if (thumb.getAttribute('data-media-thumb') === mediaId) thumb.setAttribute('aria-current', 'true');
            else thumb.removeAttribute('aria-current');
          });
        }

        initModels() {
          if (!this.querySelector('model-viewer')) return;
          if (!window.Shopify || !window.Shopify.loadFeatures) return;
          window.Shopify.loadFeatures([
            {
              name: 'model-viewer-ui',
              version: '1.0',
              onLoad: (errors) => {
                if (errors) return;
                this.querySelectorAll('model-viewer').forEach((model) => {
                  if (window.Shopify.ModelViewerUI) new window.Shopify.ModelViewerUI(model);
                });
              },
            },
          ]);
        }
      }
    );
  }

  /* ---------- Prodotti consigliati ---------- */
  if (!customElements.get('product-recommendations')) {
    customElements.define(
      'product-recommendations',
      class ProductRecommendations extends HTMLElement {
        connectedCallback() {
          const load = () => this.load();
          if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver(
              (entries) => {
                if (entries.some((e) => e.isIntersecting)) {
                  observer.disconnect();
                  load();
                }
              },
              { rootMargin: '0px 0px 400px 0px' }
            );
            observer.observe(this);
          } else {
            load();
          }
        }

        async load() {
          try {
            const response = await fetch(this.dataset.url);
            const html = await response.text();
            const doc = SG.parseHTML(html);
            const source = doc.querySelector('product-recommendations');
            if (source && source.querySelector('[data-recommendation-item]')) {
              this.innerHTML = source.innerHTML;
            } else {
              const wrapper = this.closest('.shopify-section');
              (wrapper || this).hidden = true;
            }
          } catch (error) {
            const wrapper = this.closest('.shopify-section');
            (wrapper || this).hidden = true;
          }
        }
      }
    );
  }
})();
